import api from "@/utils/api.util";

export class MissionAssetService {
  static RESOURCE = "/mission-assets/";

  static all(params = {}, options = {}) {
    return api.get(this.RESOURCE, { params, ...options });
  }

  static find(id, params = {}) {
    return api.get(this.RESOURCE + id, { params });
  }

  static create(data = {}) {
    return api.post(this.RESOURCE, data);
  }

  static export(params = {}, options = {}) {
    return api.get(this.RESOURCE + "export", { params, ...options });
  }

  static exportServiceRecords(params = {}, options = {}) {
    return api.get(this.RESOURCE + "export-service-records", {
      params,
      ...options,
    });
  }

  static listCoreIds(params = {}, options = {}) {
    return api.get(this.RESOURCE + "core-ids", { params, ...options });
  }

  static metrics(params = {}, options = {}) {
    return api.get(this.RESOURCE + "metrics", { params, ...options });
  }

  static delete(id) {
    return api.delete(this.RESOURCE + id);
  }

  static toggleFaultsResolved(id, trueOrFalse) {
    return api.post(`${this.RESOURCE}${id}/faults-resolved`, { resolved: trueOrFalse });
  }

  static fail(id, data = {}) {
    return api.post(`${this.RESOURCE}${id}/fail`, data);
  }
}
